import { FC } from "react";
import { Bar, BarChart, ResponsiveContainer } from "recharts";

import { COLORS } from "../../../localConstants.ts";
import { SharedChartOptions } from "../SharedChartOptions.tsx";
import { IntegrationErrorBarChartProps } from "./types.ts";

export const IntegrationErrorBarChart: FC<IntegrationErrorBarChartProps> = ({
    xAxisDataKey,
    data,
    displayTooltip,
    displayLegend,
}) => {
    return (
        <ResponsiveContainer width={"100%"} height={"100%"}>
            <BarChart margin={{ left: -30 }} data={data}>
                <SharedChartOptions
                    xAxisDataKey={xAxisDataKey}
                    displayLegend={displayLegend}
                    displayTooltip={displayTooltip}
                />

                <Bar type={"monotone"} name={"Chyby"} dataKey={"error"} fillOpacity={0.5} fill={COLORS.red} />
            </BarChart>
        </ResponsiveContainer>
    );
};
